import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import JsCodeEditor from "../../../components/JsCodeEditor";
import CssCodeEditor from "../../CssCodeEditor";

const SettingTab = ({updateBackToTopTabData,backToTopTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [scrollPosition, setScrollPosition] = useState(backToTopTabData.scroll_position_to_display);
    const [displayPagesType, setDisplayPagesType] = useState(backToTopTabData.setting_pages_type);
    const [selectedDevices, setSelectedDevices] = useState(backToTopTabData.setting_devices_type || []);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(backToTopTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(backToTopTabData.custom_js);

    // Handlers Scroll Position Change
    const handleScrollPositionChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        // Define min and max constants for clarity
        const MIN_SIZE = 300;
        const MAX_SIZE = 2000;
        // Clamp the value within the range
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWith = `${clampedValue}`;
        setScrollPosition(valueWith);
        updateBackToTopTabData("scroll_position_to_display", valueWith);
    };

    // Handlers Where to Display Chat Change
    const handleDisplayPagesTypeChange = (event) => {
        const value = event.target.value;
        setDisplayPagesType(value);
        updateBackToTopTabData("setting_pages_type", value);
    };

    // UseEffect Display Chat on Devices Change
    useEffect(() => {
        // Sync state if backToTopTabData updates from outside
        if (Array.isArray(backToTopTabData.setting_devices_type)) {
            setSelectedDevices(backToTopTabData.setting_devices_type);
        } else if (typeof backToTopTabData.setting_devices_type === 'string') {
            try {
            const parsed = JSON.parse(backToTopTabData.setting_devices_type);
            setSelectedDevices(parsed);
            } catch (e) {
            // Fallback if not a valid JSON string
            const devicesFromString = backToTopTabData.setting_devices_type.split(',').map(item => item.trim());
            setSelectedDevices(devicesFromString);
            }
        }
    }, [backToTopTabData.setting_devices_type]); 

    // Handlers Display Chat on Devices Change
    const handleDeviceChange = (event) => {
        const { value, checked } = event.target;
        let updatedDevices = [...selectedDevices];
    
        if (checked) {
            if (!updatedDevices.includes(value)) {
            updatedDevices.push(value);
            }
        } else {
            updatedDevices = updatedDevices.filter(device => device !== value);
        }
    
        setSelectedDevices(updatedDevices);
        updateBackToTopTabData("setting_devices_type", JSON.stringify(updatedDevices));
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateBackToTopTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateBackToTopTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Scroll Position to Display</span>
                            <em>{scrollPosition}</em>
                            <div className="slider-container">
                                <input type="range" min="300" max="2000" value={parseInt(scrollPosition)} onChange={handleScrollPositionChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("pages")}>Pages <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("devices")}>Devices <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>

                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                        <p>Adjust your bar's visibility for your website's pages and user devices. You can also set up a display schedule.</p>
                    </div>
                </>
            )}
            

            {activeSettingElementsTab === "pages" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Pages</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="all_pages" type="radio" value="All_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'All_Pages'}/>
                                            <label for="all_pages">All Pages</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "devices" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Devices</span>
                        <div className="side-baar-box-header">
                            <span>Show on Devices</span>
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="desktop_device" type="checkbox" value="Desktop" checked={selectedDevices.includes("Desktop")} onChange={handleDeviceChange}/>
                                            <label for="desktop_device">Desktop</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="tablets_device" type="checkbox" value="Tablets" checked={selectedDevices.includes("Tablets")} onChange={handleDeviceChange} />
                                            <label for="tablets_device">Tablets</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="phones_device" type="checkbox" value="Phones" checked={selectedDevices.includes("Phones")} onChange={handleDeviceChange} />
                                            <label for="phones_device">Phones</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;